/**
 * 11549: строка в окне «Отправить лист учета в 1С ERP ещё раз?» — сколько раз лист уже уходил в 1С
 * и когда последний раз (МСК).
 *
 * sentToErpAt сдвигается при каждой отправке — первой и кнопкой, — поэтому это время последней.
 * Раз = первая отправка + нажатия кнопки (события sheet_resent_to_erp). Ручные повторы через смену
 * статуса, которые делали до появления кнопки, сюда не попадают.
 */
export function erpSendSummary(sentToErpAt: string | null, resendCount: number): string {
  const sent = new Date(sentToErpAt || '');
  if (Number.isNaN(sent.getTime())) {
    return 'Отметки об отправке листа в 1С ERP в Medeo нет.';
  }
  const times = 1 + Math.max(0, resendCount || 0);
  const lastTwo = times % 100;
  const word = [2, 3, 4].includes(times % 10) && (lastTwo < 12 || lastTwo > 14) ? 'раза' : 'раз';
  const when = sent.toLocaleString('ru-RU', {
    timeZone: 'Europe/Moscow', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
  return `Лист уже отправляли в 1С ERP ${times} ${word}, последний раз — ${when} МСК.`;
}
